export default __webpack_public_path__ + "img/fiat-professional-logo.f263aa8f.png";